const COUNTRY_STORAGE_KEYS = ["taxCountry", "companyCountry", "country"];

export const normalizeCountry = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

export const getCountry = (...candidates) => {
  const values = candidates.flat ? candidates.flat(Infinity) : candidates;

  for (const candidate of values) {
    const normalized = normalizeCountry(candidate);
    if (normalized) {
      return normalized;
    }
  }

  return "";
};

export const getCountryFromLocationState = (state = {}) =>
  getCountry(state?.taxCountry, state?.country);

export const getStoredCountry = () => {
  if (typeof window === "undefined") return "";

  for (const key of COUNTRY_STORAGE_KEYS) {
    try {
      const value = window.localStorage.getItem(key);
      const normalized = normalizeCountry(value);
      if (normalized) {
        return normalized;
      }
    } catch (error) {
      // Ignore storage access issues and try the next source.
    }
  }

  return "";
};

export const resolveCountry = (state = {}) =>
  getCountry(getCountryFromLocationState(state), getStoredCountry());

export const persistSelectedCountry = (country) => {
  if (typeof window === "undefined") return "";

  const normalized = normalizeCountry(country);
  if (!normalized) return "";

  try {
    window.localStorage.setItem("taxCountry", normalized);
  } catch (error) {
    // Ignore storage access issues and continue with the resolved value.
  }

  return normalized;
};
